import { FunctionComponent } from "react";
import { Tooltip } from "@mui/material";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { reformatDateTime } from "util/DateUtil";

type PropsType = {
  /** Whether anything is pending at all; nothing is drawn otherwise. */
  pending: boolean;
  /** The status the row is at now, already labelled for people. */
  statusLabel: string;
  /** When the change landed, ISO string; omitted from the tooltip if unknown. */
  changedAt?: string | null;
};

// The "something happened to this row from the other side" marker, shared by
// the requisition list and the inquiry board. The two lists mirror each
// other: the Inquiry moves the requisition, the requester moves the Inquiry,
// and each side needs telling until somebody opens the row. Same icon and
// same tooltip on both so it reads as one thing.
//
// It sits inside the Status cell rather than in a column of its own: it
// qualifies the status it is drawn next to, and an extra column would be
// empty on almost every row.
const StatusUpdateIndicator: FunctionComponent<PropsType> = ({
  pending,
  statusLabel,
  changedAt,
}) => {
  if (!pending) return null;
  const when = changedAt ? reformatDateTime(changedAt) : null;
  return (
    <Tooltip
      title={`New status applied: ${statusLabel}${when ? ` (${when})` : ""}`}
    >
      <NewReleasesIcon
        fontSize="small"
        color="warning"
        aria-label="Unacknowledged status update"
      />
    </Tooltip>
  );
};

export default StatusUpdateIndicator;
